import dayjs from 'dayjs';
export const FORM_CHANGE_BOOKING = ({ defaultValues }) => {
  const expireDate = defaultValues.expireDate;
  console.log('expireDate', expireDate);
  return [
    {
      name: 'expireDate',
      label: 'สิ้นสุดรับประกัน',
      type: 'INPUT',
      value: expireDate ? dayjs(expireDate).format('DD/MM/YYYY') : '-',
      span: 24,
      disabled: true,
    },
    {
      name: 'bookingDate',
      label: 'เลื่อนวันที่เข้ารับบริการ',
      type: 'DATE_PICKER',
      span: 24,
      rules: {
        required: true,
      },
      disabledDate: (current) => {
        const bookingDate = defaultValues.bookingDate ? dayjs(defaultValues.bookingDate) : null;
        const minDate =
          bookingDate > dayjs() ? dayjs(defaultValues.bookingDate).add(1, 'day') : dayjs();
        const maxDateByRule = bookingDate > dayjs() ? dayjs(bookingDate).add(14, 'day') : dayjs();
        const expireMaxDate = expireDate ? dayjs(expireDate).startOf('day') : null;
        const maxDate =
          expireMaxDate && expireMaxDate.isValid() && expireMaxDate.isBefore(maxDateByRule)
            ? expireMaxDate
            : maxDateByRule;
        return current < minDate || current > maxDate;
      },
    },
    {
      name: 'remark',
      label: 'ข้อความ (ระบุได้ไม่เกิน 250 ตัวอักษร)',
      type: 'INPUT_AREA',
      placeholder: '',
      span: 24,
      rules: {
        required: true,
        maxLength: 250,
      },
    },
  ];
};
